import { NgModule,  CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
///////////////////////////////////////////////////////
import { initializeApp,provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
///////////////////////////////////////////////////////////////////
import { ArgumentsComponent } from './comp/arguments/arguments.component';
import { CourtierComponent } from './comp/courtier/courtier.component';
import { HomeComponent } from './comp/home/home.component';
import { MaisonComponent } from './comp/maison/maison.component';
import { ServicesComponent } from './comp/services/services.component';
import { SlidesComponent } from './comp/slides/slides.component';
import { SpecialistesComponent } from './comp/specialistes/specialistes.component';
///////////////////////////////////////////////////////////////
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DevisComponent } from './comp/devis/devis.component';
import { SharedModule } from './modules/shared/shared.module';
import { RappelezMoiComponent } from './comp/rappelez-moi/rappelez-moi.component';
import { provideFirestore } from '@angular/fire/firestore';
import { provideMessaging } from '@angular/fire/messaging';
import { getFirestore } from 'firebase/firestore';
import { getMessaging } from 'firebase/messaging';

@NgModule({
  declarations: [
    AppComponent,
    ArgumentsComponent,
    CourtierComponent,
    HomeComponent,
    MaisonComponent,
    ServicesComponent,
    SlidesComponent,
    SpecialistesComponent,
    DevisComponent,
    RappelezMoiComponent,
    
  ],

  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    SharedModule,
    FormsModule,
    HttpClientModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideMessaging(() => getMessaging()),
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
